'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Games {
  fetch(url) {
    return __async(this, null, function* () {
      try {
        const content = yield transport.transport.getHttpDriver().get(url);
        return JSON.parse(content);
      } catch (e) {
        console.error("Could not fetch games list from", url, e);
        return [];
      }
    });
  }
  getLastPlayedGames(params) {
    return transport.transport.request("users/getLastGamesPlayed", params);
  }
  getRecentWinners(params) {
    return transport.transport.request("games/getRecentWinners", params);
  }
  jackpots(params) {
    return transport.transport.request("games/jackpots", params);
  }
  getFavourites() {
    return transport.transport.request("games/getFavourites");
  }
  launchUrl(params) {
    return transport.transport.request("games/launchUrl", params);
  }
  checkForActiveSessions() {
    return transport.transport.request("games/checkForActiveSessions");
  }
  deleteActiveSessions(params) {
    return transport.transport.request("games/deleteActiveSessions", params);
  }
  browser(params) {
    return transport.transport.request("games/browser", params);
  }
  favourite(params) {
    return transport.transport.request("games/favourite", params);
  }
  getRecommendedGames(params) {
    return transport.transport.request("games/getRecommendedGames", params);
  }
  getGREMarketRecommendations(params) {
    return transport.transport.request("games/getGREMarketRecommendations", params);
  }
  getDynamicUserRecommendedCategory(params) {
    return transport.transport.request("games/getGREUserRecommendations", params);
  }
  getGRESimilarGameRecommendations(params) {
    return transport.transport.request("games/getGRESimilarGameRecommendations", params);
  }
}

exports.Games = Games;
